module.exports = __webpack_public_path__ + "img/store-play-co.f9ac739.png";